define('viewModels/privileged/qm/EditCalibrationView',[
    'lib/lodash4',
    'lib/knockout',
    'lib/bluebird',
    'util/errorCallbackFactory',
    'viewModels/ViewModel',
    'viewModels/privileged/qm/policies/editors/AgentSelectorView',
    'viewModels/privileged/qm/util/ServiceResponseValidator',
    'viewModels/privileged/composer/forms/formEditor/Evaluation',
    'viewModels/privileged/composer/forms/formEditor/FormEditorState',

    // No reference needed
    'extensions/i18n/knockout.i18n'
], function (_,
             ko,
             Promise,
             errorCallbackFactory,
             ViewModel,
             AgentSelectorView,
             ServiceResponseValidator,
             EvaluationView,
             FormEditorState
             ) {
    'use strict';

    var EditCalibrationView = ViewModel.extend(function (calibrationObservable) {
        var self = this;

        self.expertEvaluator = ko.observable();
        self.scoringIndex = ko.observable();
        self.isExpertEvaluation = ko.observable();

        var responseValidator = new ServiceResponseValidator();
        self.evaluators = ko.observable(calibrationObservable().evaluators()).extend({responseValidator: responseValidator});

        var formEditorState = new FormEditorState();
        formEditorState.setEvaluatorActionMode();
        self.evaluationView = self.subView(EvaluationView,
                                           calibrationObservable().evaluationForm(),
                                           null,
                                           formEditorState);

        self.evaluatorSelector = self.subView(AgentSelectorView, self.evaluators);

        self.subscribe(self.isExpertEvaluation, function (newValue) {
            if (newValue) {
                var expertEvaluator = calibrationObservable().expertEvaluator ? calibrationObservable().expertEvaluator() : undefined;
                self.expertEvaluator(expertEvaluator);
            }
        });

        self.getResponseValidator = function() {
            return responseValidator;
        };

        self.reset = function () {
            self.isExpertEvaluation(false);
            if (calibrationObservable().expertEvaluator) {
                self.isExpertEvaluation(true);
            }
        };
        self.reset();

        self.getCalibration = function() {

            var calibration = {
                id: calibrationObservable().id,
                agent: { id: calibrationObservable().agent().id() },
                conversation: { id: calibrationObservable().conversation().id() },
                evaluationForm: { id: calibrationObservable().evaluationForm().id },
                evaluators: _.map(self.evaluators(), function (evaluator) {
                    return { id: evaluator.id };
                })
            };

            if (self.isExpertEvaluation()) {
                calibration.expertEvaluator = { id: self.expertEvaluator().id };
            }

            return calibration;
        };
    });
    return EditCalibrationView;
});
